/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const registerPageStyle = {
  background: (theme: Theme) => ({
    paddingTop: "5rem",
    paddingBottom: "2.5rem",
    backgroundColor: "#f4f4f4",
    [theme.breakpoints.down("md")]: {
      height: "70vh",
      minHeight: 600,
    },
  }),
  loginContainer: {
    maxWidth: "23rem",
    padding: 0,
  },
  imgDescription: {
    marginTop: "2.5rem",
    maxWidth: "100%",
  },
  loginContent: {
    padding: "1.5rem",
  },
  loginTitle: {
    fontSize: "1.25rem",
    textAlign: "center",
    padding: "1rem 1.5rem",
    fontWeight: 500,
    color: "primary.main",
    borderBottom: "1px solid #f4f4f4",
  },
};

export default registerPageStyle;
